<template>
  <div class="outer-wrapper">
    <div class="inner-page animate__animated animate__slideInRight">
      <div class="container-fluid">
        <div class="card card-form ">
          <div class="card-body p-0">
            <b-form @submit.prevent="createLead">
              <b-form-group>
                <label for="name">Name <span class="text-danger">*</span></label>
                <b-form-input id="name" type="text" placeholder="Name" v-model="$v.lead.name.$model"></b-form-input>
                  <div class="error" v-if="$v.lead.name.$error">Field is required</div>
              </b-form-group>

                <b-form-group >
                <label for="enquiry">Enquiry <span class="text-danger">*</span></label>
                <b-form-input id="enquiry" type="text" placeholder="Enquiry" v-model="$v.lead.enquiry.$model"></b-form-input>
                <div class="error" v-if="$v.lead.enquiry.$error">Field is required</div>

              </b-form-group>
               <b-form-group>
                   <label for="tags">Tags <span class="text-danger">*</span></label>
                <b-form-input id="tags" type="text" placeholder="Tags" v-model="$v.lead.tags.$model"></b-form-input>
                   <div class="error" v-if="$v.lead.tags.$error">Field is required</div>
              </b-form-group>

               <b-form-group>
                   <label for="phone">Phone <span class="text-danger">*</span></label>
                <b-form-input id="phone" type="text" placeholder="Phone" v-model="$v.lead.phone.$model"></b-form-input>
                 <div class="error" v-if="$v.lead.phone.$error">Field is required</div>
              </b-form-group>

              <b-form-group  label="Email" label-for="email">
                <b-form-input id="email" placeholder="Email" v-model="$v.lead.email.$model" ></b-form-input>
              </b-form-group>
              <b-form-group class="form-group  mb-4">
                <label for="firmName">Select Status <span class="text-danger">*</span></label>
                <SingleTagInput
                  textLabel="Lead Status"
                  :masterList="statusList"
                  :addItem="selectStatus"
                  :removeItem="removeStatus"
                  :selectedItem="selectedStatus"
                />
                <div class="error" v-if="hasStatusError && $v.selectedStatus.$invalid">
                  Field is required
                </div>
              </b-form-group>

              <b-form-group label="Add Comment" label-for="comment">
                <b-form-textarea id="comment" v-model="lead.comments" placeholder="Add Comment" rows="3" max-rows="6"></b-form-textarea>
              </b-form-group>
              <b-form-group>
                <div class="row mt-4">
                  <div class="col-8">
                    <b-button type="submit" variant="primary" block :disabled="$v.$invalid">Create Lead</b-button>
                  </div>
                  <div class="col-4 text-center">
                    <router-link class="btn btn-primary-outline text-muted" :to="{name: 'Home'}" > Cancel</router-link>
                  </div>
                </div>
              </b-form-group>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SingleTagInput from "@/components/Forms/SingleTagInput.vue";
import { required, minLength, maxLength, email} from 'vuelidate/lib/validators';
import { validationMessage } from 'vuelidate-messages'
const formMessages = {
  required: () => 'Field is required',
  txtMinLen: ({ $params }) => `Must be at least ${$params.txtMinLen.min} characters.`,
  txtMaxLen: ({ $params }) => `Must be at most ${$params.txtMaxLen.max} characters.`,
  email: () => 'Should be valid email',
}
export default {
  name: "NewLead",
  components: {
    SingleTagInput
  },
  data() {
    return {
      lead: {
        name: null,
        phone: null,
        email: null,
        enquiry: null,
        status_id: null,
        tags: null,
        comments: null
      },
      selectedStatus: {},
      hasStatusError: false,
    };
  },
  validations: {
    lead: {
      name: {
        required
      },
      enquiry: {
        required
      },
      phone: {
        required,
        txtMinLen: minLength(8),
        txtMaxLen: maxLength(15)
      },
      email: {
        email
      },
      tags: {
        required
      },
    },
    selectedStatus: {
      required
    },
  },
  methods: {
    created() {
      this.fetchLeadDetail();
    },
    createLead() {
      this.lead.status_id = this.selectedStatus.id
      this.$axios
        .post("leads", { lead: this.lead })
        .then(res => {
          swal({
            title: "Lead Created!",
            icon: "success"
          }).then(this.$router.replace({ name: "Home" }));
        })
      .catch(err => {
        if (err.response.status === 500) {
          swal({
            title: "Server Error!",
            icon: "error"
          });
        } else {
          swal({
            title: "Error",
            text: err.response.data.message,
            icon: "error"
          });
        }
      });
    },
    selectStatus(status) {
      this.selectedStatus = status;
      this.hasStatusError = true
    },
    removeStatus() {
      this.selectedStatus = {};
    },
  },
  computed: {
    statusList() {
      return this.$store.getters.statusesMaster;
    },
    validationMsg(){
      return validationMessage(formMessages);
    }
  },
};
</script>

